import $ from 'jquery';
import { isElement, forEach } from 'lodash';
import mustache from 'mustache';
import 'slick-carousel';

import Breakpoint from '../../01-helpers/breakpoint-util';
import containerManager from '../../01-helpers/filter-context/container-manager';
import { get as getPageOptions } from '../../01-helpers/utilities/options';
import { stringToNode } from '../../01-helpers/utilities/node';
import { publish } from '../../01-helpers/event-manager';

import { PILL_REMOVED, FILTER_CHANGED } from '../../02-const/event-names';

const moduleName = 'filter-pills',
    selectors = {
        base: `.js-${moduleName}`,
        container: `.js-${moduleName}-container`,
        pill: `.js-${moduleName}-pill`,
        title: `.js-${moduleName}-title`,
        resultItemTemplate: '#resultItemTemplate'
    },
    translationsKey = {
        key: 'translations',
        from: 'DateFrom',
        until: 'DateUntil'
    },
    className = {
        hide: 'u-visually-hidden'
    },
    config = {
        arrows: false,
        dots: false,
        infinite: false,
        variableWidth: true
    },
    pillTemplate = `<button type="button" class="c-button c-button--filter js-filter-pills-pill">{{ Name }}</button>`;

export class FilterPills {

    constructor(baseElement) {
        if (!isElement(baseElement)) {
            return false;
        }

        this._config(baseElement);
        this._setup();

    }


    bindEvents() {
        // update carousel if resize to mobile
        document.addEventListener('resize', () => this._initSlider());

        //add pill when filter is selected
        this.filterContext.onUpdate(({ currentState }) => {
            const filters = currentState.Filters;
            let filterIds = [];

            this._resetSlider();
            this.pillContainer.innerHTML = '';

            this._setTitle(filters);

            forEach(filters, (filter) => {

                // check if filter is already added
                if (filterIds.includes(filter.Id)) {
                    return false;
                }

                filterIds.push(filter.Id);

                let pillValue;

                switch (filter.Type) {
                    case 'date_start':
                        pillValue = `${this.translations[translationsKey.from]} ${filter.Value}`;
                        break;
                    case 'date_end':
                        pillValue = `${this.translations[translationsKey.until]} ${filter.Value}`;
                        break;
                    default:
                        pillValue = filter.Name;
                        break;
                }

                    const data = { Name: pillValue },
                    pillElement = stringToNode(mustache.render(pillTemplate, data));

                pillElement.dataset.id = filter.Id;

                //add pill to pillContainer
                this.pillContainer.appendChild(pillElement);
                pillElement.addEventListener('click', (event) => this._removePill(event));
            });

            this._initSlider();
            
        });

        //remove pill when filter is deselected (subscribe to filterSelect)
        //remove pill when pill is clicked
            //publish event so other modules can act on removal
    }

    _removePill(ev) {
        this._resetSlider();

        const pill = ev.currentTarget,
            id = pill.dataset.id;

        pill.remove();
        // publish event so other modules can act on removal
        publish(PILL_REMOVED, { 'id': id });
        //publish(FILTER_CHANGED);
    }

    _setTitle(filters) {
        if (filters.length > 0) {
            this.filterTitle.classList.remove(className.hide);
        } else {
            this.filterTitle.classList.add(className.hide);
        }
    }

    _initSlider() {
        if (Breakpoint.isPalm() && !this.$slider.hasClass('slick-initialized')) {
            this.$slider.slick(config);
        }
    }

    _resetSlider() {
        try {
            if (Breakpoint.isPalm() && this.$slider.hasClass('slick-initialized')) {
                this.$slider.slick('unslick');
            }
        } catch (e) {
            // unable to unslick slider.
        }
        
    }

    _config(baseElement) {
        this.baseElement = baseElement;
        this.filterContext = containerManager.getContainer();
        this.filterTitle = this.baseElement.querySelector(selectors.title);
        this.pillContainer = this.baseElement.querySelector(selectors.container);
        this.$slider = $(this.pillContainer);
    }

    _setup() {
        this.translations = getPageOptions(translationsKey.key);
        this._initSlider();        
        this.bindEvents();
    }
}

const initFilterPills = () => {
    forEach(document.querySelectorAll(selectors.base), (pillElement) => {
        new FilterPills(pillElement);
    });
};

initFilterPills();